import React, { Component } from 'react'

export default class SafeRetirementBar extends Component {
  constructor (props) {
    super(props)

    this.width = this.props.width || 300
    this.scaleFactor = this.width / 100
    this.viewBox = `0 0 ${this.width} 30`
    this.className = this.props.className || 'ui-card__content'
  }

  pathString (percentage) {
    let circleCenter
    if (percentage < 15 / this.scaleFactor) {
      circleCenter = 15
    } else if (percentage > 100 - 15 / this.scaleFactor) {
      circleCenter = this.width - 15
    } else {
      circleCenter = Math.floor(percentage * this.scaleFactor)
    }
    circleCenter = isNaN(circleCenter) ? 0 : circleCenter

    return `M 0 10 L ${circleCenter - 10} 10 C ${circleCenter - 5} 2 ${circleCenter + 5} 2 ${circleCenter + 10} 10 L ${this.width} 10 L ${this.width} 20 L ${circleCenter + 10} 20 C ${circleCenter + 5} 28 ${circleCenter - 5} 28 ${circleCenter - 10} 20 L 0 20`
  }

  render () {
    return (
      <div className={this.className}>
        <div className='progress-bar'>
          <div style={{ position: 'relative', height: '35px', width: '100%', padding: 0, paddingBottom: `${100 * (this.props.height / this.props.width)}%` }}>
            <svg viewBox={this.viewBox} xmlns='http://www.w3.org/2000/svg' style={{ position: 'absolute', height: '100%', width: '100%', left: 0, top: 0 }}>
              <defs>
                <linearGradient id='retirement-gradient'>
                  <stop offset='0%' stopColor='#BF616A' />
                  <stop offset='50%' stopColor='#EBCB8B' />
                  <stop offset='100%' stopColor='#A3CE8C' />
                </linearGradient>
              </defs>
              <g fill="url('#retirement-gradient')">
                <path d={this.pathString(this.props.percentage)} />
              </g>
            </svg>
          </div>
        </div>
      </div>
    )
  }
}
